/* 🤖 this file was generated by svg-to-ts */
export const matIconSensorDoor: {
  name: 'sensor-door';
  data: string;
} = {
  name: 'sensor-door',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 4v16H6V4h12m0-2H6c-1.1 0-2 .9-2 2v18h16V4c0-1.1-.9-2-2-2zm-2.5 8.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S17 12.83 17 12s-.67-1.5-1.5-1.5z"/></svg>`
};
